var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import { useQueryClient } from 'react-query';
import dayjs from 'dayjs';
import { ArrowLeft, Check, FlaskConical, Info, Layers, Plus, Scan, Stethoscope, Syringe, X } from 'lucide-react';
import EmptyComponent from 'components/EmptyComponent';
import localeTranslator from 'library/Hocs/LocalTranslator';
import queries from 'constants/queries';
import { ServiceOrder } from 'models';
import AppointmentFilters from 'models/appEntities/AppointmentFilters';
import ServiceOrderItem from 'models/entities/ServiceOrderItem';
import services from 'services';
import '../style.css';
var ORDER_ENTITY_TYPES = [
    'lab',
    'ray',
    'procedure',
    'other'
];
var formatAppointmentTime = function (value) {
    if (!value)
        return '—';
    var parsed = dayjs(value);
    return parsed.isValid() ? parsed.format('DD/MM/YYYY hh:mm A') : '—';
};
var isAvailableOrderEntityPrice = function (price, entityId) {
    if (price.getEntityType() !== 'OrderEntity')
        return false;
    if (entityId != null && price.getEntityId() !== entityId)
        return false;
    if (!price.getIsEnabled())
        return false;
    var now = Date.now();
    var started = new Date(price.started_at).getTime();
    if (Number.isNaN(started) || started > now)
        return false;
    if (price.finished_at) {
        var finished = new Date(price.finished_at).getTime();
        if (!Number.isNaN(finished) && finished <= now)
            return false;
    }
    return true;
};
var AddJourneyStepDrawer = function (props) {
    var t = props.translate, visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, journey = props.journey, clinics = props.clinics, canCreateServiceOrder = props.canCreateServiceOrder, canAddAppointment = props.canAddAppointment;
    var queryClient = useQueryClient();
    var appointmentService = services.appointmentService, patientJourneyService = services.patientJourneyService, orderEntityService = services.orderEntityService, packagePriceService = services.packagePriceService, receptionDeskService = services.receptionDeskService, serviceOrderService = services.serviceOrderService;
    var _a = patientJourneyService.useAppendStep(), appendStep = _a.mutateAsync, isAppending = _a.isLoading;
    var _b = serviceOrderService.useCreateServiceOrder(), createOrder = _b.mutate, createSucceeded = _b.isSuccess, createFailed = _b.isError, resetCreate = _b.reset;
    var _c = useState('appointment'), category = _c[0], setCategory = _c[1];
    var _d = useState([]), selectedAppointmentIds = _d[0], setSelectedAppointmentIds = _d[1];
    var _e = useState(journey.getClinicId()), selectedClinicId = _e[0], setSelectedClinicId = _e[1];
    var _f = useState(), selectedDeskId = _f[0], setSelectedDeskId = _f[1];
    var _g = useState(), selectedEntityId = _g[0], setSelectedEntityId = _g[1];
    var _h = useState(), selectedPriceId = _h[0], setSelectedPriceId = _h[1];
    var _j = useState(false), submitting = _j[0], setSubmitting = _j[1];
    var appointmentFilters = useMemo(function () {
        var filters = new AppointmentFilters();
        filters.setPatientId(journey.getPatientId());
        filters.setWithoutJourneyStep(true);
        return filters;
    }, [journey]);
    var _k = appointmentService.useAllAppointments(appointmentFilters), patientAppointments = _k.data, isLoadingAppointments = _k.isLoading;
    var orderEntities = orderEntityService.useOrderEntities({
        is_enabled: true
    }).data;
    var packagePrices = packagePriceService.usePackagePrices().data;
    var desks = receptionDeskService.useReceptionDesks(selectedClinicId ? { clinic_id: selectedClinicId, active: true } : {}).data;
    var journeyClinicId = journey.getClinicId();
    var nextStep = journey.getSteps().length + 1;
    var appointmentRows = useMemo(function () {
        return __spreadArray([], (patientAppointments || []), true).filter(function (appointment) { return appointment.isLinkableToJourneyStep(); })
            .sort(function (left, right) {
            var _a, _b;
            var leftClinicId = ((_a = left.getClinic()) === null || _a === void 0 ? void 0 : _a.getId()) || left.getClinicId();
            var rightClinicId = ((_b = right.getClinic()) === null || _b === void 0 ? void 0 : _b.getId()) || right.getClinicId();
            var leftHere = leftClinicId === journeyClinicId ? 0 : 1;
            var rightHere = rightClinicId === journeyClinicId ? 0 : 1;
            if (leftHere !== rightHere)
                return leftHere - rightHere;
            return dayjs(right.time).valueOf() - dayjs(left.time).valueOf();
        });
    }, [patientAppointments, journeyClinicId]);
    var availablePricesFor = function (entityId) {
        if (!entityId)
            return [];
        return (packagePrices || [])
            .filter(function (price) { return isAvailableOrderEntityPrice(price, entityId); })
            .sort(function (left, right) { return Number(right.getIsOffer()) - Number(left.getIsOffer()); });
    };
    var entitiesWithPrice = useMemo(function () {
        return (orderEntities || []).filter(function (entity) {
            return (packagePrices || []).some(function (price) {
                return isAvailableOrderEntityPrice(price, entity.getId());
            });
        });
    }, [orderEntities, packagePrices]);
    var categories = useMemo(function () {
        var list = [];
        if (canAddAppointment)
            list.push('appointment');
        if (canCreateServiceOrder) {
            var present_1 = new Set(entitiesWithPrice.map(function (entity) { return entity.getEntityType(); }));
            ORDER_ENTITY_TYPES.forEach(function (type) {
                if (present_1.has(type))
                    list.push(type);
            });
        }
        return list;
    }, [canAddAppointment, canCreateServiceOrder, entitiesWithPrice]);
    var entityOptions = useMemo(function () {
        if (category === 'appointment')
            return [];
        return entitiesWithPrice
            .filter(function (entity) { return entity.getEntityType() === category; })
            .map(function (entity) { return ({
            value: entity.getId(),
            label: entity.getName()
        }); });
    }, [entitiesWithPrice, category]);
    var clinicOptions = useMemo(function () {
        return (clinics || []).map(function (clinic) { return ({
            value: clinic.getId(),
            label: clinic.getName()
        }); });
    }, [clinics]);
    var deskOptions = useMemo(function () {
        return (desks || []).map(function (desk) { return ({
            value: desk.getId(),
            label: desk.getName()
        }); });
    }, [desks]);
    var priceOptions = useMemo(function () {
        return availablePricesFor(selectedEntityId).map(function (price) { return ({
            value: price.getId(),
            label: price.getPackageName() || "#".concat(price.getId())
        }); });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedEntityId, packagePrices]);
    useEffect(function () {
        if (!visiable)
            return;
        setSelectedAppointmentIds([]);
        setSelectedClinicId(journey.getClinicId());
        setSelectedDeskId(undefined);
        setSelectedEntityId(undefined);
        setSelectedPriceId(undefined);
        setSubmitting(false);
        resetCreate();
    }, [visiable, journey, resetCreate]);
    useEffect(function () {
        if (!visiable || categories.length === 0)
            return;
        setCategory(function (current) {
            return categories.includes(current) ? current : categories[0];
        });
    }, [visiable, categories]);
    useEffect(function () {
        if (createSucceeded) {
            setSubmitting(false);
            onCloseDrawer();
        }
    }, [createSucceeded, onCloseDrawer]);
    useEffect(function () {
        if (createFailed)
            setSubmitting(false);
    }, [createFailed]);
    var onSelectCategory = function (next) {
        setCategory(next);
        setSelectedAppointmentIds([]);
        setSelectedEntityId(undefined);
        setSelectedPriceId(undefined);
    };
    var toggleAppointment = function (id) {
        setSelectedAppointmentIds(function (prev) {
            return prev.includes(id) ? prev.filter(function (item) { return item !== id; }) : __spreadArray(__spreadArray([], prev, true), [id], false);
        });
    };
    var onAddAppointments = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _i, selectedAppointmentIds_1, appointmentId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedAppointmentIds.length)
                        return [2 /*return*/];
                    _i = 0, selectedAppointmentIds_1 = selectedAppointmentIds;
                    _a.label = 1;
                case 1:
                    if (!(_i < selectedAppointmentIds_1.length)) return [3 /*break*/, 4];
                    appointmentId = selectedAppointmentIds_1[_i];
                    return [4 /*yield*/, appendStep({
                            patientJourneyId: journey.getId(),
                            stepableType: 'Appointment',
                            stepableId: appointmentId,
                            stepKind: 'appointment',
                            successMessage: t('messages.stepAppended')
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    queryClient.invalidateQueries(queries.appointments);
                    onCloseDrawer();
                    return [2 /*return*/];
            }
        });
    }); };
    var onCreateServiceOrder = function () {
        if (!selectedClinicId || !selectedEntityId || !selectedPriceId)
            return;
        var order = new ServiceOrder();
        order.setPatientId(journey.getPatientId());
        order.setClinicId(selectedClinicId);
        order.setReceptionDeskId(selectedDeskId);
        order.setPatientJourneyId(journey.getId());
        order.setStatus('pending');
        var item = new ServiceOrderItem();
        item.setOrderEntityId(selectedEntityId);
        item.setPackagePriceId(selectedPriceId);
        item.setStatus('pending');
        order.setItems([item]);
        setSubmitting(true);
        createOrder({
            serviceOrder: order,
            items: [item],
            successMessage: t('messages.orderCreatedAndAppended')
        });
    };
    var onPrimary = function () {
        if (category === 'appointment') {
            void onAddAppointments();
            return;
        }
        onCreateServiceOrder();
    };
    var busy = isAppending || submitting;
    var canSubmit = category === 'appointment'
        ? selectedAppointmentIds.length > 0 && !busy
        : Boolean(selectedClinicId && selectedEntityId && selectedPriceId) && !busy;
    var categoryMeta = {
        appointment: {
            icon: _jsx(Stethoscope, { size: 18, strokeWidth: 2 }),
            titleKey: 'stepKinds.appointment',
            hintKey: 'addStep.categoryHints.appointment'
        },
        lab: {
            icon: _jsx(FlaskConical, { size: 18, strokeWidth: 2 }),
            titleKey: 'stepKinds.lab',
            hintKey: 'addStep.categoryHints.lab'
        },
        ray: {
            icon: _jsx(Scan, { size: 18, strokeWidth: 2 }),
            titleKey: 'stepKinds.ray',
            hintKey: 'addStep.categoryHints.ray'
        },
        procedure: {
            icon: _jsx(Syringe, { size: 18, strokeWidth: 2 }),
            titleKey: 'stepKinds.procedure',
            hintKey: 'addStep.categoryHints.procedure'
        },
        other: {
            icon: _jsx(Layers, { size: 18, strokeWidth: 2 }),
            titleKey: 'stepKinds.other',
            hintKey: 'addStep.categoryHints.other'
        }
    };
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onCloseDrawer, closable: false, destroyOnClose: true, width: 560, rootClassName: "pj-step-drawer", className: "pj-step-drawer", children: _jsxs("div", { className: "pj-step-drawer__shell", children: [_jsx("header", { className: "pj-step-drawer__header", children: _jsxs("div", { className: "pj-step-drawer__title-row", children: [_jsxs("div", { className: "pj-step-drawer__title-block", children: [_jsx("button", { type: "button", className: "pj-step-drawer__icon-btn pj-step-drawer__icon-btn--bordered", onClick: onCloseDrawer, "aria-label": t('common:buttons.close'), children: _jsx(ArrowLeft, { size: 16, strokeWidth: 2 }) }), _jsxs("div", { children: [_jsx("h2", { className: "pj-step-drawer__title", children: t('addStep.title') }), _jsx("p", { className: "pj-step-drawer__subtitle", children: t('addStep.subtitle', {
                                                    patient: journey.getPatientName(),
                                                    id: journey.getId(),
                                                    step: nextStep
                                                }) })] })] }), _jsx("button", { type: "button", className: "pj-step-drawer__icon-btn", onClick: onCloseDrawer, "aria-label": t('common:buttons.close'), children: _jsx(X, { size: 18, strokeWidth: 2 }) })] }) }), _jsxs("div", { className: "pj-step-drawer__body", children: [_jsxs("div", { className: "pj-step-drawer__banner", children: [_jsx(Info, { size: 20, strokeWidth: 2, "aria-hidden": true }), _jsxs("p", { children: [_jsx("strong", { children: t('addStep.bannerTitle') }), ' ', t('addStep.bannerBody')] })] }), categories.length > 0 ? (_jsxs("div", { className: "pj-step-drawer__field", children: [_jsxs("label", { className: "pj-step-drawer__label", children: [t('addStep.category'), _jsx("span", { className: "pj-step-drawer__req", children: "*" })] }), _jsx("div", { className: "pj-step-drawer__categories", children: categories.map(function (item) {
                                        var meta = categoryMeta[item];
                                        var selected = category === item;
                                        return (_jsxs("button", { type: "button", className: "pj-step-drawer__category".concat(selected ? ' is-selected' : ''), onClick: function () { return onSelectCategory(item); }, children: [_jsx("span", { className: "pj-step-drawer__category-icon".concat(selected ? ' is-selected' : ''), "aria-hidden": true, children: meta.icon }), _jsxs("span", { className: "pj-step-drawer__category-text", children: [_jsx("span", { className: "pj-step-drawer__category-title", children: t(meta.titleKey) }), _jsx("span", { className: "pj-step-drawer__category-hint", children: t(meta.hintKey) })] })] }, item));
                                    }) })] })) : null, category === 'appointment' ? (_jsxs("div", { className: "pj-step-drawer__field", children: [_jsxs("div", { className: "pj-step-drawer__list-head", children: [_jsxs("label", { className: "pj-step-drawer__label", children: [t('addStep.appointments'), _jsx("span", { className: "pj-step-drawer__req", children: "*" })] }), _jsx("span", { className: "pj-step-drawer__selected-count".concat(selectedAppointmentIds.length ? ' is-active' : ''), children: t('addStep.selectedCount', {
                                                count: selectedAppointmentIds.length
                                            }) })] }), _jsx("p", { className: "pj-step-drawer__hint", children: t('form.appointmentSectionHint') }), isLoadingAppointments ? (_jsx("div", { className: "pj-step-drawer__empty", children: t('addStep.loading') })) : appointmentRows.length === 0 ? (_jsxs("div", { className: "pj-step-drawer__empty", children: [_jsx(EmptyComponent, {}), _jsx("p", { children: t('form.noAppointments') })] })) : (_jsx("div", { className: "pj-step-drawer__list", children: appointmentRows.map(function (appointment) {
                                        var _a, _b, _c, _d;
                                        var id = appointment.getId();
                                        var selected = selectedAppointmentIds.includes(id);
                                        var clinicId = ((_a = appointment.getClinic()) === null || _a === void 0 ? void 0 : _a.getId()) ||
                                            appointment.getClinicId();
                                        var doctorName = appointment.doctor
                                            ? (_c = (_b = appointment.getDoctor()) === null || _b === void 0 ? void 0 : _b.getUser()) === null || _c === void 0 ? void 0 : _c.getName()
                                            : undefined;
                                        var clinicName = appointment.clinic
                                            ? (_d = appointment.getClinic()) === null || _d === void 0 ? void 0 : _d.getName()
                                            : undefined;
                                        return (_jsxs("button", { type: "button", className: "pj-step-drawer__card".concat(selected ? ' is-selected' : ''), onClick: function () { return toggleAppointment(id); }, children: [_jsxs("div", { className: "pj-step-drawer__card-top", children: [_jsxs("div", { className: "pj-step-drawer__card-main", children: [_jsx("span", { className: "pj-step-drawer__check".concat(selected ? ' is-on' : ''), "aria-hidden": true, children: selected ? (_jsx(Check, { size: 12, strokeWidth: 3 })) : null }), _jsx("span", { className: "pj-step-drawer__card-name", children: formatAppointmentTime(appointment.time) }), clinicId === journeyClinicId ? (_jsx("span", { className: "pj-step-drawer__chip", children: t('form.sameClinic') })) : null] }), _jsx("span", { className: "pj-step-drawer__status", children: appointment.getDisplayedStatus() ||
                                                                appointment.getStatus() ||
                                                                '—' })] }), _jsx("p", { className: "pj-step-drawer__card-meta", children: [doctorName, clinicName].filter(Boolean).join(' • ') ||
                                                        '—' })] }, id));
                                    }) }))] })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: "pj-step-drawer__field", children: [_jsxs("label", { className: "pj-step-drawer__label", children: [t('addStep.serviceName'), _jsx("span", { className: "pj-step-drawer__req", children: "*" })] }), _jsx(Select, { className: "pj-step-drawer__control", popupClassName: "pj-step-drawer__select-dropdown", placeholder: t('addStep.serviceNamePlaceholder'), options: entityOptions, value: selectedEntityId, onChange: function (value) {
                                                var prices = availablePricesFor(value);
                                                setSelectedEntityId(value);
                                                setSelectedPriceId(prices.length === 1 ? prices[0].getId() : undefined);
                                            }, showSearch: true, optionFilterProp: "label", notFoundContent: t('addStep.noServices') })] }), _jsxs("div", { className: "pj-step-drawer__field", children: [_jsxs("label", { className: "pj-step-drawer__label", children: [t('addStep.station'), _jsx("span", { className: "pj-step-drawer__req", children: "*" })] }), _jsx(Select, { className: "pj-step-drawer__control", popupClassName: "pj-step-drawer__select-dropdown", placeholder: t('addStep.stationPlaceholder'), options: clinicOptions, value: selectedClinicId, onChange: function (value) {
                                                setSelectedClinicId(value);
                                                setSelectedDeskId(undefined);
                                            }, showSearch: true, optionFilterProp: "label" })] }), deskOptions.length > 0 ? (_jsxs("div", { className: "pj-step-drawer__field", children: [_jsx("label", { className: "pj-step-drawer__label", children: t('addStep.receptionDesk') }), _jsx(Select, { className: "pj-step-drawer__control", popupClassName: "pj-step-drawer__select-dropdown", placeholder: t('addStep.receptionDeskPlaceholder'), options: __spreadArray([
                                                { value: 0, label: t('addStep.noDesk') }
                                            ], deskOptions, true), value: selectedDeskId !== null && selectedDeskId !== void 0 ? selectedDeskId : 0, onChange: function (value) {
                                                return setSelectedDeskId(value === 0 ? undefined : value);
                                            }, allowClear: true })] })) : null, _jsxs("div", { className: "pj-step-drawer__quota", children: [_jsx("div", { className: "pj-step-drawer__quota-head", children: _jsxs("span", { className: "pj-step-drawer__label", children: [t('addStep.carePackage'), _jsx("span", { className: "pj-step-drawer__req", children: "*" })] }) }), _jsx(Select, { className: "pj-step-drawer__control", popupClassName: "pj-step-drawer__select-dropdown", placeholder: selectedEntityId
                                                ? priceOptions.length === 0
                                                    ? t('addStep.noPackagePrice')
                                                    : t('addStep.carePackagePlaceholder')
                                                : t('addStep.pickServiceFirst'), options: priceOptions, value: selectedPriceId, onChange: function (value) { return setSelectedPriceId(value); }, disabled: !selectedEntityId, showSearch: true, optionFilterProp: "label" })] })] }))] }), _jsxs("footer", { className: "pj-step-drawer__footer", children: [_jsxs("div", { className: "pj-step-drawer__sync", children: [_jsx("span", { className: "pj-step-drawer__sync-dot", "aria-hidden": true }), _jsx("span", { children: t('addStep.syncLabel', { id: journey.getId() }) })] }), _jsxs("div", { className: "pj-step-drawer__footer-actions", children: [_jsx("button", { type: "button", className: "pj-step-drawer__btn pj-step-drawer__btn--ghost", onClick: onCloseDrawer, disabled: busy, children: t('common:buttons.cancel') }), _jsxs("button", { type: "button", className: "pj-step-drawer__btn pj-step-drawer__btn--primary", onClick: onPrimary, disabled: !canSubmit, children: [_jsx(Plus, { size: 16, strokeWidth: 2.5 }), _jsx("span", { children: category === 'appointment'
                                                ? t('actions.addAppointment')
                                                : t('addStep.submit') })] })] })] })] }) }));
};
export default localeTranslator(AddJourneyStepDrawer, 'patientJourneys');
